import React from "react";

const DeleteIcon = ({
    width="22",
    height= "22"
}) => {
  return (
    <svg
      id="trsh_ic"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22.089 22.259"
    >
      <path
        id="Path_348"
        data-name="Path 348"
        d="M23.872,37.057H18.01a3.827,3.827,0,0,1-2.549-.977,4.1,4.1,0,0,1-1.274-2.421L12.7,21.467a.8.8,0,0,1,.085-.34.459.459,0,0,1,.3-.127H28.715a.379.379,0,0,1,.382.467L27.61,33.659a3.879,3.879,0,0,1-1.274,2.421A3.658,3.658,0,0,1,23.872,37.057ZM13.592,21.85l1.444,11.724a2.886,2.886,0,0,0,.977,1.869,3.046,3.046,0,0,0,1.954.765h5.9a2.762,2.762,0,0,0,1.954-.765,2.886,2.886,0,0,0,.977-1.869L28.248,21.85Z"
        transform="translate(-9.769 -14.798)"
      ></path>
      <path
        id="Path_349"
        data-name="Path 349"
        d="M27.465,10.308H25.553A3.294,3.294,0,0,0,22.2,8.1H20.8a1.786,1.786,0,0,0-1.657-1.7H14.551a1.55,1.55,0,0,0-1.232.637A1.949,1.949,0,0,0,12.894,8.1H11.535a3.8,3.8,0,0,0-2.379.765,2.679,2.679,0,0,0-.977,1.444H6.225a.425.425,0,1,0,0,.85h21.24a.425.425,0,0,0,0-.85ZM14,7.547a.833.833,0,0,1,.595-.34h4.5c.382,0,.722.382.85.892h-6.2A1.112,1.112,0,0,1,14,7.547ZM9.071,10.308a1.713,1.713,0,0,1,.595-.765,3.069,3.069,0,0,1,1.869-.595h10.7A2.555,2.555,0,0,1,24.7,10.308Z"
        transform="translate(-5.8 -6.4)"
      ></path>
      <path
        id="Path_350"
        data-name="Path 350"
        d="M31.525,37.082a.4.4,0,0,1-.425-.425V25.825a.425.425,0,0,1,.85,0V36.657A.457.457,0,0,1,31.525,37.082Z"
        transform="translate(-20.353 -17.329)"
      ></path>
      <path
        id="Path_351"
        data-name="Path 351"
        d="M39.225,37.032h0a.463.463,0,0,1-.425-.467l1.147-10.79c.042-.212.255-.425.467-.382a.462.462,0,0,1,.382.467L39.65,36.65A.452.452,0,0,1,39.225,37.032Z"
        transform="translate(-24.782 -17.321)"
      ></path>
      <path
        id="Path_352"
        data-name="Path 352"
        d="M22.263,37.031a.452.452,0,0,1-.425-.382l-1.147-10.79a.422.422,0,0,1,.382-.467.4.4,0,0,1,.467.382l1.147,10.79a.422.422,0,0,1-.382.467Z"
        transform="translate(-14.362 -17.32)"
      ></path>
    </svg>
  );
};

export default DeleteIcon;
